import { useEffect, useRef } from 'react';

export default function VerifyCodeForm({
    email,
    digits,
    onDigitChange,
    onPaste,
    rememberDevice,
    onRememberDeviceChange,
    showRememberDevice = true,
    onSubmit,
    onResend,
    error,
    success,
    resendBusy,
    onBack
}) {
    const inputsRef = useRef([]);

    useEffect(() => {
        inputsRef.current[0]?.focus();
    }, []);

    const handleChange = (index, value) => {
        const digit = value.replace(/\D/g, '').slice(-1);
        onDigitChange(index, digit);
        if (digit && index < 5) {
            inputsRef.current[index + 1]?.focus();
        }
    };

    const handleKeyDown = (index, event) => {
        if (event.key === 'Backspace' && !digits[index] && index > 0) {
            inputsRef.current[index - 1]?.focus();
        }
    };

    return (
        <>
            <h1>Confirm your email</h1>
            <p className="auth-subtitle">Enter the 6-digit code sent to {email}.</p>

            <form onSubmit={onSubmit} className="auth-form">
                <div className="auth-otp" onPaste={onPaste}>
                    {digits.map((digit, index) => (
                        <input
                            key={index}
                            ref={el => { inputsRef.current[index] = el; }}
                            className="auth-otp-input"
                            inputMode="numeric"
                            maxLength={1}
                            value={digit}
                            onChange={e => handleChange(index, e.target.value)}
                            onKeyDown={e => handleKeyDown(index, e)}
                            aria-label={`Digit ${index + 1}`}
                        />
                    ))}
                </div>

                {showRememberDevice && (
                    <label className="auth-terms">
                        <input type="checkbox" checked={rememberDevice} onChange={e => onRememberDeviceChange(e.target.checked)} />
                        <span>Remember this device for 30 days</span>
                    </label>
                )}

                {error && <div className="auth-error"><i className="fa-solid fa-triangle-exclamation"></i>{error}</div>}
                {success && <div className="auth-success">{success}</div>}

                <button type="submit" className="btn-primary auth-submit" disabled={digits.join('').length !== 6}>Continue</button>
            </form>

            <p className="auth-switch">
                Didn&apos;t get it?{' '}
                <button type="button" className="auth-link" onClick={onResend} disabled={resendBusy}>Resend code</button>
            </p>
            <p className="auth-support">If you need help, email us at <a href="mailto:support@rulestore.com">support@rulestore.com</a>.</p>
            <p className="auth-switch">
                <button type="button" className="auth-link muted" onClick={onBack}>Back to sign in</button>
            </p>
        </>
    );
}
